import styled, { keyframes } from "styled-components";
import { motion } from "framer-motion";
import { float } from "../../styles/animations";

export const HeroWrapper = styled.section`
  width: 100%;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 3}px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 15;

  @media (min-width: 1025px) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 1440px;
    margin: 0 auto;
    padding: ${({ theme }) => theme.CONSTANTS.XH * 6}px 1vw;
    text-align: left;
  }
`;

export const HeroTextBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 1025px) {
    width: 50%;
    align-items: flex-start;
    padding-right: 4rem;
  }
`;

export const HeroImageBlock = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;

  @media (min-width: 1025px) {
    width: 50%;
    margin-top: 0;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

const glowPulse = keyframes`
  0% {
    box-shadow: 0 0 0 rgba(0, 217, 255, 0.0);
  }
  50% {
    box-shadow: 0 0 16px rgba(0, 217, 255, 0.5);
  }
  100% {
    box-shadow: 0 0 0 rgba(0, 217, 255, 0.0);
  }
`;

const borderMove = keyframes`
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
`;

export const FloatingIcon = styled.div`
  position: absolute;
  animation: ${float} 20s ease-in-out infinite;
  opacity: 0.8;

  &.icon-play {
    top: -175%;
    left: 5%;
  }

  &.icon-music {
    top: -148%;
    right: 10%;
  }

  &.icon-star {
    top: -115%;
    right: 15%;
  }

  img {
    width: 48px;
    height: 48px;
    filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.2));
  }

  @media (min-width: 1025px) {
    &.icon-play {
      top: 5%;
      left: 0%;
    }

    &.icon-music {
      top: 7%;
      right: 6%;
    }

    &.icon-star {
      top: 35%;
      right: 55%;
    }
  }
`;

export const DJImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 520px;
  user-select: none;
  pointer-events: none;
  object-fit: contain;

  @media (min-width: 1025px) {
    margin-top: ${({ theme }) => theme.CONSTANTS.XH * 8}px;
  }
`;

export const NeonPink = styled.span`
  color: ${({ theme }) => theme.THEME.neonPink};
  font-weight: 600;
`;

export const NeonBlue = styled.span`
  color: ${({ theme }) => theme.THEME.neonBlue};
  font-weight: 600;
`;

export const MotionSubtitle = styled(motion.h2)`
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 25}px;
  font-weight: 700;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  font-family: "Sora", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
  }
`;

export const MotionTitle = styled(motion.h1)`
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 35}px;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  width: 85%;
  max-width: 450px;
  font-family: "Sora", sans-serif;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 14}px;
    width: 100%;
  }
`;

export const MotionDescriptionBlock = styled(motion.div)`
  margin: ${({ theme }) => theme.CONSTANTS.XH * 5}px auto 0 auto;
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 28}px;
  line-height: 1.6;
  max-width: 450px;
  font-family: "Sora", sans-serif;
  text-align: start;
  width: 88%;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
    width: 100%;
    max-width: none;
    margin: ${({ theme }) => theme.CONSTANTS.XH * 4}px 0 0 0;
  }
`;

export const MotionDescription = styled(motion.div)`
  margin: ${({ theme }) => theme.CONSTANTS.XH * 1}px auto 0 auto;
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  line-height: 1.6;
  max-width: 450px;
  font-family: "Inter", sans-serif;
  align-items: flex-start;
  text-align: start;
  width: 88%;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
    width: 100%;
    margin: ${({ theme }) => theme.CONSTANTS.XH * 4}px 0 0 0;
  }
`;
